import { Grid, IconButton, InputAdornment } from "@mui/material";
import { RHFRoundedTextField, RHFSwitch } from "components/minimal/hook-form";
import Iconify from "components/minimal/iconify";
import { useBoolean } from "hooks/use-boolean";
import { IFormProps } from "types/form-props";
import UserReport from "../user-report/user-report-list-view";
import ChallengeUserReport from "views/management/challenge-user-report/challenge-user-report-list-view";
import StoryReport from "views/overview/story-report/story-report-list-view";

interface ChildrenFormProps extends IFormProps {}

const ChildrenForm: React.FC<ChildrenFormProps> = ({
  formOperation,
  currentItem,
}) => {
  const password = useBoolean();

  return (
    <>
      <Grid item xs={6}>
        <RHFRoundedTextField name="firstName" label="First Name" />
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="lastName" label="Last Name" />
      </Grid>
      {formOperation === "Create" && (
        <Grid item xs={6}>
          <RHFRoundedTextField
            name="password"
            label="Password"
            type={password.value ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={password.onToggle} edge="end">
                    <Iconify
                      icon={
                        password.value
                          ? "solar:eye-broken"
                          : "solar:eye-closed-bold"
                      }
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}

      <Grid item xs={6}>
        <RHFRoundedTextField
          name="reportsCount"
          label="Reports Count"
          disabled
        />
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField
          name="reportsCountContent"
          label="Reports Count Content"
          disabled
        />
      </Grid>

      <Grid item xs={6}>
        <RHFRoundedTextField
          name="username"
          label="User Name"
          autoComplete="new-password"
          disabled={formOperation === "Update"}
        />
      </Grid>

      <Grid item xs={6}>
        <RHFSwitch name="blocked" label="Blocked" />
      </Grid>

      {!!currentItem?.reportsCount && (
        <Grid item xs={12}>
          <UserReport userId={currentItem?.id} />
        </Grid>
      )}

      {!!currentItem?.reportsCountContent && (
        <>
          <Grid item xs={12}>
            <StoryReport userId={currentItem?.id} />
          </Grid>
          <Grid item xs={12}>
            <ChallengeUserReport userId={currentItem?.id} />
          </Grid>
        </>
      )}
    </>
  );
};

export default ChildrenForm;
